import Alpine from 'alpinejs';
import { SignInResponse } from '../storage/types';
import { firebaseSigninClient } from '../client/FirebaseSigninClient';

export const getAlpineAuth = () => Alpine.data('authFlow', () => ({
  email: '',
  password: '',
  loading: false,
  error: null,
  view: 'login', // 'login' or 'signup'

  async signInWithEmail() {
    this.loading = true;
    this.error = null;

    try {
      const user = await firebaseSigninClient.signInWithEmail(this.email, this.password);
      await this.handleAuthSuccess(user);
    } catch (error) {
      this.error = 'Invalid email or password';
      this.loading = false;
    }
  },

  async signInWithGoogle() {
    this.loading = true;
    this.error = null;

    try {
      const user = await firebaseSigninClient.signInWithGoogle();
      await this.handleAuthSuccess(user);
    } catch (error) {
      this.error = 'Failed to sign in with Google';
      this.loading = false;
    }
  },

  async handleAuthSuccess(user: SignInResponse) {
    if (user.isNewUser) {
      // New user - redirect to onboarding
      window.location.href = '/onboarding/link-accounts';
    } else {
      // Existing user - redirect to dashboard
      window.location.href = '/dashboard';
    }
  }
}));

